module.exports = __webpack_public_path__ + "img/album22_04.1df8c3f2.jpg";